import { render } from "./CloudSaveStatus.vue?vue&type=template&id=2ffdb03b&ts=true"
import script from "./CloudSaveStatus.vue?vue&type=script&lang=ts"
export * from "./CloudSaveStatus.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__